<template>
  <div class="app-container crm-follow-list">
    <el-form :model="queryParams" ref="queryForm" v-show="showSearch" label-width="85px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="公司简称" prop="name">
            <el-input v-model="queryParams.name" placeholder="请输入公司简称" clearable/>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="18" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="dataList">
      <el-table-column label="公司简称" min-width="100" align="center" prop="tenantName"/>
      <el-table-column label="公司全称" min-width="100" align="center" prop="tenantFullName"/>
      <el-table-column label="用户昵称" min-width="100" align="center" prop="linkNickName"/>
      <el-table-column label="手机号" min-width="100" align="center" prop="linkTel"/>
      <el-table-column label="创建人" width="100" align="center" prop="createUserName"/>
      <el-table-column label="创建时间" width="170" align="center" prop="createTime" />
<!--      <el-table-column label="操作" width="100" align="center" fixed="right" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="text"  @click="handleEdit(scope.row)">编辑</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList"/>

    <AddTenantDialog ref="addTenantDialogRef" @success="getList"></AddTenantDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {queryTenantPage} from "@/api/system/tenant";
import AddTenantDialog from "@/views/saas/tenant/addTenantDialog";

export default {
  name: "Tenant",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      dataList: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: null
      }
    };
  },
  computed: {
    ...mapState({
      currentUserId: state => state.user.userId
    })
  },
  components: {
    AddTenantDialog
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      queryTenantPage(this.queryParams).then(response => {
          this.dataList = response.rows;
          this.total = response.total;
          this.loading = false;
        }
      ).catch(error => {
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.createBy = null;
      this.handleQuery();
    },
    handleAdd() {
      this.$refs.addTenantDialogRef.open();
    },
    handleEdit(row) {

    }
  }
};
</script>

<style lang='scss'>
.crm-follow-list {
  .content {
    word-break: break-all;
    line-height: 1.5em;
  }
}
</style>
